import {BaseMaps} from "../../../_models/map/basemaps/basemaps"
import {ConfigService} from "../../config.service"
import {Injectable} from "@angular/core"
import {MapLayer} from "src/app/_models/map/map-layers/map-layer.model"
@Injectable({
	providedIn: "root",
})
export class MapLayersService {
	constructor() {}
	private mapLayers: MapLayer[] = null
	getMapLayers() {
		return this.mapLayers
	}
	setMapLayers(layersArr: MapLayer[]) {
		this.mapLayers = layersArr
	}
	getBaseMaps() {
		return BaseMaps
	}
}
